<!-- <h2 mat-dialog-title>Confirm Rejection</h2> -->
 <div style="background-color: white;">
<mat-dialog-content class="mat-typography">
  <p style="margin-top: 8px; font-size: 16px;">Are you sure to Reject <strong>#{{data}} ?</strong></p>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-flat-button mat-dialog-close color="primary" (click)="onConfirm()">Yes</button>
  <button mat-flat-button color="primary" mat-dialog-close (click)="onCancel()">No</button>
</mat-dialog-actions>
</div>